// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file types/v1/request_source.proto (package types.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file types/v1/request_source.proto.
 */
export const file_types_v1_request_source: GenFile = /*@__PURE__*/
  fileDesc("Ch10eXBlcy92MS9yZXF1ZXN0X3NvdXJjZS5wcm90bxIIdHlwZXMudjEquQEKDVJlcXVlc3RTb3VyY2USHgoaUkVRVUVTVF9TT1VSQ0VfVU5TUEVDSUZJRUQQABIZChVSRVFVRVNUX1NPVVJDRV9QT1JUQUwQARIZChVSRVFVRVNUX1NPVVJDRV9CUk9LRVIQAhIbChdSRVFVRVNUX1NPVVJDRV9FWFRFUk5BTBADEhsKF1JFUVVFU1RfU09VUkNFX0RFVl9UT09MEAQSGAoUUkVRVUVTVF9TT1VSQ0VfQkFUQ0gQBUKnAQoMY29tLnR5cGVzLnYxQhJSZXF1ZXN0U291cmNlUHJvdG9QAVpCZ2l0aHViLmNvbS9lbmVjaGFpbi9lcG9zaXRpb24tYXBwL2JhY2tlbmQvZ2VuL3Byb3RvL3R5cGVzL3YxO3R5cGVzogIDVFhYqgIIVHlwZXMuVjHKAghUeXBlc1xWMeICFFR5cGVzXFYxXEdQQk1ldGFkYXRh6gIJVHlwZXM6OlYxYgZwcm90bzM");

/**
 * RequestSource はリクエストの流入経路を表す
 *
 * @generated from enum types.v1.RequestSource
 */
export enum RequestSource {
  /**
   * Default or unknown source
   *
   * @generated from enum value: REQUEST_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Portal application
   *
   * @generated from enum value: REQUEST_SOURCE_PORTAL = 1;
   */
  PORTAL = 1,

  /**
   * Broker application
   *
   * @generated from enum value: REQUEST_SOURCE_BROKER = 2;
   */
  BROKER = 2,

  /**
   * External API integration
   *
   * @generated from enum value: REQUEST_SOURCE_EXTERNAL = 3;
   */
  EXTERNAL = 3,

  /**
   * Dev tool
   *
   * @generated from enum value: REQUEST_SOURCE_DEV_TOOL = 4;
   */
  DEV_TOOL = 4,

  /**
   * Batch process
   *
   * @generated from enum value: REQUEST_SOURCE_BATCH = 5;
   */
  BATCH = 5,
}

/**
 * Describes the enum types.v1.RequestSource.
 */
export const RequestSourceSchema: GenEnum<RequestSource> = /*@__PURE__*/
  enumDesc(file_types_v1_request_source, 0);

